export default {
  getters: {
    mobileStyles(state, getters, roostate) {
      var styles = roostate.store.ViewConfig.UiColours.Mobile;
      return {
        CommonColorTxt: {
          color: `${styles.CommonColor} !important`
        },
        StatusPendingTxt: {
          color: `${styles.StatusPending} !important`
        },
        LinkColorTxt: {
          color: `#0000dd !important`
        },
        btn: {
          background: styles.ButtonColour,
          border: 0,
          color: styles.ButtonText
        },
        alertInfoBackGround: {
          background: styles.CommonColor
        },
        TitleBar: {
          "background-color": `${styles.TitleBar} !important`
        },
        nav: {
          "background-color": `#dddddd !important`
        },
        MenuHighlight: {
          "border-color": `${styles.MenuHighlight} !important`
        },
        MenuHighlightedText: {
          color: `${styles.MenuHighlightedText} !important`
        },
        menuItemColor: {
          color: `${styles.CommonColor} !important`
        },
        primaryBackgroundColour: {
          "background-color": `#eeeeee !important`
        },
        primaryColour: {
          color: `#212529`
        },
        primaryColourImportant: {
          color: `#212529 !important`
        },
        CommonColorBackground: {
          "background-color": `${styles.CommonColor} !important`
        },
        pendingStatusBackground: {
          "background-color": `${styles.StatusPending} !important`
        },
        successMsg: {
          color: `#4CAF50`,
          "border-color": `#4CAF50`,
          "border-width": "1px",
          "border-style": "solid",
          "border-radius": ".3rem"
        },
        errorMsg: {
          color: `#E91E63`,
          "border-color": `#E91E63`,
          "border-width": "1px",
          "border-style": "solid",
          "border-radius": ".3rem",
          margin: "0.5rem",
          padding: "0.3rem"
        },
        roolIntoButton: {
          color: "#ffffff",
          "border-color": "#0275d8",
          "border-width": "1px",
          "border-style": "solid",
          "border-radius": ".1rem",
          margin: "0.5rem",
          padding: "0.3rem",
          background: "#0275d8",
          width: "96%"
        },
        primaryColor: {
          color: "#ffffff"
        },
        stepProgressBarBeforeCommonColor: {
          content: "",
          display: "block",
          margin: "0px auto 4px",
          "background-color": `${styles.CommonColor}`,
          width: "30px",
          height: "30px",
          "line-height": "28px",
          "text-align": "center",
          "font-weight": "bold",
          "border-width": "2px",
          "border-style": "solid",
          "border-color": `${styles.CommonColor}`,
          "border-radius": "50%"
        },
        stepProgressBarBeforePendingColor: {
          content: "",
          display: "block",
          margin: "0px auto 4px",
          "background-color": `${styles.StatusPending}`,
          width: "30px",
          height: "30px",
          "line-height": "28px",
          "text-align": "center",
          "font-weight": "bold",
          "border-width": "2px",
          "border-style": "solid",
          "border-color": `${styles.StatusPending}`,
          "border-radius": "50%"
        },
        stepProgressBarAfterCommonColor: {
          content: "",
          height: "4px",
          width: "100%",
          "background-color": `${styles.CommonColor}`,
          position: "absolute",
          top: "12px",
          left: "50%",
          "z-index": "-1"
        },
        stepProgressBarAfterPendingColor: {
          content: "",
          height: "4px",
          width: "100%",
          "background-color": `${styles.StatusPending}`,
          position: "absolute",
          top: "12px",
          left: "50%",
          "z-index": "-1"
        }
      };
    },
    mobileColours(state, getters, roostate) {
      return roostate.store.ViewConfig.UiColours.Mobile;
    },
    desktopStyles(state, getters, roostate) {
      var styles = roostate.store.ViewConfig.UiColours.Desktop;
      return {
        btn: {
          background: styles.ButtonColour,
          border: 0,
          color: styles.ButtonText
        },
        CommonColorTxt: {
          color: `${styles.CommonColor} !important`
        },
        StatusPendingTxt: {
          color: `${styles.StatusPending} !important`
        },
        LinkColorTxt: {
          color: `#0000dd !important`
        },
        primaryColor: {
          color: "#ffffff !important"
        },
        alertInfoBackGround: {
          background: styles.CommonColor
        },
        TitleBar: {
          "background-color": styles.TitleBar
        },
        nav: {
          "background-color": `#dddddd !important`
        },
        MenuHighlight: {
          "border-color": `${styles.MenuHighlight} !important`
        },
        MenuHighlightedText: {
          color: `${styles.MenuHighlightedText} !important`
        },
        primaryBodyBackground: {
          "background-color": `#eeeeee !important`
        },
        CommonColorBackground: {
          "background-color": `${styles.CommonColor} !important`
        },
        pendingStatusBackground: {
          "background-color": `${styles.StatusPending} !important`
        },
        successMsg: {
          color: `#0275d8`,
          "border-color": `#0275d8`,
          "border-width": "1px",
          "border-style": "solid",
          "border-radius": ".3rem"
        },
        errorMsg: {
          color: `#E91E63`,
          "border-color": `#E91E63`,
          "border-width": "1px",
          "border-style": "solid",
          "border-radius": ".3rem"
        },
        roolIntoButton: {
          "border-color": "#0275d8",
          "border-width": "1px",
          "border-style": "solid",
          background: "#0275d8",
          color: "#ffffff",
          width: "100%"
        },
        stepProgressBarBeforeCommonColor: {
          content: "",
          display: "block",
          margin: "0px auto 4px",
          "background-color": `${styles.CommonColor}`,
          width: "30px",
          height: "30px",
          "line-height": "28px",
          "text-align": "center",
          "font-weight": "bold",
          "border-width": "2px",
          "border-style": "solid",
          "border-color": `${styles.CommonColor}`,
          "border-radius": "50%"
        },
        stepProgressBarBeforePendingColor: {
          content: "",
          display: "block",
          margin: "0px auto 4px",
          "background-color": `${styles.StatusPending}`,
          width: "30px",
          height: "30px",
          "line-height": "28px",
          "text-align": "center",
          "font-weight": "bold",
          "border-width": "2px",
          "border-style": "solid",
          "border-color": `${styles.StatusPending}`,
          "border-radius": "50%"
        },
        stepProgressBarAfterCommonColor: {
          content: "",
          height: "4px",
          width: "100%",
          "background-color": `${styles.CommonColor}`,
          position: "absolute",
          top: "12px",
          left: "50%",
          "z-index": "-1"
        },
        stepProgressBarAfterPendingColor: {
          content: "",
          height: "4px",
          width: "100%",
          "background-color": `${styles.StatusPending}`,
          position: "absolute",
          top: "12px",
          left: "50%",
          "z-index": "-1"
        }
      };
    }
  }
};
